





























































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { debounce, get } from 'lodash-es'
import { requestGet } from '@/api/request'
import constants from '@/utils/constants'
import { getCountryCodeAndPhone, isPhoneNumber } from '@/utils/helpers'

@Component({
  methods: {
    formatDate(val: any) {
      let date: any = val
      if (moment(date).isValid()) {
        date = moment(date).utc().format('DD MMM YYYY')
      }
      return date
    }
  }
})
export default class CustomAutocomplete extends Vue {
  @Prop() apiPath!: string
  @Prop({ default: '' }) source?: string
  @Prop({ default: 'query' }) queryField?: string
  @Prop({ default: 'label' }) optionLabel?: string | string[]
  @Prop({ default: 'label' }) inputValue?: string | string[]
  @Prop({ default: () => ({}) }) filter?: object
  @Prop({ default: 'Type to search' }) placeholder?: string
  @Prop({ default: '' }) sortByField?: string
  @Prop({ default: 'asc' }) sortType?: string
  @Prop({ default: false }) canAddNewUser?: boolean
  $refs!: {
    input: HTMLInputElement
  }

  protected searchText: string = ''
  protected options: any[] = []
  protected isLoading: boolean = false
  protected getResult: boolean = false
  protected errorMessage: any = null
  protected showDropdown: boolean = false
  protected addKey = '__ADD__'

  // 使用debounce处理输入变化
  protected debouncedSearch = debounce(this.fetchData, 1000)

  onInputChange(text: string) {
    this.showDropdown = true
    if (text.length < 3) {
      this.options = []
      this.getResult = false
      return
    }
    this.debouncedSearch(text)
  }

  fetchData(text: string) {
    this.errorMessage = null
    this.isLoading = true
    this.options = []
    requestGet(this.apiPath, {
      [(this.queryField) as string]: text,
      ...this.filter
    })
      .then(result => {
        let data: any[] = []
        if (result.data.code === constants.STATUS_200_STRING) {
          data = result.data.data.map((item: any) => {
            let label: string
            let value: string
            if (Array.isArray(this.optionLabel)) {
              label = this.optionLabel.map(key => get(item, key)).join(' - ')
            } else {
              label = item[this.optionLabel as string]
            }
            if (Array.isArray(this.inputValue)) {
              value = this.inputValue.map(key => get(item, key)).join(' - ')
            } else {
              value = item[this.inputValue as string]
            }
            if (!item['lastOrderId']) {
              item['lastOrderDate'] = ''
            }
            return {
              ...item,
              suggestionOptionLabel: label,
              suggestionInputValue: value
            }
          })

          if (this.sortByField && data.every(item => item[this.sortByField as string] !== undefined && item[this.sortByField as string] !== null)) {
            data.sort((a, b) => {
              const aValue = a[this.sortByField as string]
              const bValue = b[this.sortByField as string]
              if (aValue < bValue) {
                return this.sortType === 'asc' ? -1 : 1
              }
              if (aValue > bValue) {
                return this.sortType === 'asc' ? 1 : -1
              }
              return 0
            })
          }
        }
        if (this.source === 'searchUser' && this.canAddNewUser) {
          data.unshift({
            lastOrderDate: '',
            lastOrderId: '',
            name: this.addKey,
            phoneNumber: '',
            suggestionInputValue: text,
            suggestionOptionLabel: ''
          })
        }
        this.options = data
      })
      .catch(err => {
        console.error(err)
        this.options = []
        this.errorMessage = err.message
      })
      .finally(() => {
        this.getResult = true
        this.isLoading = false
      })
  }

  focusHandler() {
    this.setValue('')
    this.showDropdown = true
  }

  onSelected(option: any) {
    if (get(option, 'name') === this.addKey) {
      this.onAddNewUser()
    } else {
      this.emitInputText(option)
      this.setValue(option.suggestionInputValue)
      this.showDropdown = false
    }
  }

  getValue(): string {
    return this.searchText
  }

  setValue(val: string = '') {
    this.searchText = val
  }

  onAddNewUser() {
    const inputValue = this.getValue()
    const isPhone = isPhoneNumber(inputValue)
    const data = {
      customerName: '',
      phoneNumber: '',
      countryCode: ''
    }
    if (isPhone) {
      const { phoneNumber, countryCode } = getCountryCodeAndPhone(inputValue)
      data.phoneNumber = phoneNumber || ''
      data.countryCode = countryCode || ''
    } else {
      data.customerName = inputValue || ''
    }
    this.$emit('add-new-user', data)
  }

  emitInputText(item: any) {
    this.$emit('input-text', item)
  }

  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement
    if (this.$el && !this.$el.contains(target)) {
      this.showDropdown = false
    }
  }
}
